// ============================================================
// VidyaTrack — Landing Navbar  (no login link)
// ============================================================
import React, { useState, useEffect } from "react";
import { FiMenu, FiX } from "react-icons/fi";

const P = { primary:"#054bb4", textMed:"#374151", border:"#e4e9f2" };

export default function LandingNav({ scroll }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 32);
    window.addEventListener("scroll", fn, { passive:true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const nav = (id) => { setMenuOpen(false); scroll(id); };

  const linkStyle = {
    background:"none", border:"none", cursor:"pointer",
    fontSize:"0.875rem", fontWeight:500, color:P.textMed,
    fontFamily:"Inter,sans-serif", padding:"6px 2px",
    transition:"color .15s",
  };

  return (
    <header style={{
      position:"fixed", top:0, left:0, right:0, zIndex:900,
      background: scrolled?"rgba(255,255,255,.97)":"rgba(255,255,255,.80)",
      backdropFilter:"blur(12px)",
      borderBottom:`1px solid ${scrolled?P.border:"transparent"}`,
      boxShadow: scrolled?"0 2px 20px rgba(5,75,180,.07)":"none",
      transition:"all .3s",
    }}>
      <div style={{
        maxWidth:1140, margin:"0 auto",
        padding:"0 max(20px,calc((100vw - 1140px)/2))",
        height:64, display:"flex", alignItems:"center", justifyContent:"space-between",
      }}>
        {/* Logo */}
        <a href="/" aria-label="VidyaTrack home" style={{ display:"flex", alignItems:"center", gap:10, textDecoration:"none" }}>
          <img src="/vtLight.png" alt="VidyaTrack — School Management System Nepal" width={40} height={40} style={{ width:40, height:40, objectFit:"contain" }}/>
          <div>
            <div style={{ fontFamily:"'Poppins',sans-serif", fontWeight:800, fontSize:"1rem", color:P.primary, lineHeight:1 }}>VidyaTrack</div>
            <div style={{ fontSize:"0.6rem", color:"#9ca3af", marginTop:1 }}>School Management</div>
          </div>
        </a>

        {/* Desktop nav */}
        <nav aria-label="Primary" style={{ display:"flex", gap:28, alignItems:"center" }} className="vt-nav-links">
          {[["Features","features"],["How It Works","how-it-works"],["Pricing","pricing"],["Contact","contact"]].map(([lbl,id])=>(
            <button key={id} onClick={()=>nav(id)} style={linkStyle}
              onMouseEnter={e=>e.currentTarget.style.color=P.primary}
              onMouseLeave={e=>e.currentTarget.style.color=P.textMed}>
              {lbl}
            </button>
          ))}
        </nav>

        {/* Desktop CTA */}
        <button
          onClick={()=>nav("contact")}
          className="vt-nav-cta"
          style={{ background:"linear-gradient(135deg,#054bb4,#2e5caf)", color:"#fff",
            padding:"9px 22px", borderRadius:10, border:"none", cursor:"pointer",
            fontWeight:600, fontSize:"0.875rem", fontFamily:"Inter,sans-serif",
            boxShadow:"0 4px 14px rgba(5,75,180,.28)", transition:"all .2s" }}
          onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-1px)";e.currentTarget.style.boxShadow="0 6px 20px rgba(5,75,180,.38)";}}
          onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="0 4px 14px rgba(5,75,180,.28)";}}>
          Book a Demo
        </button>

        {/* Hamburger */}
        <button className="vt-hamburger" onClick={()=>setMenuOpen(o=>!o)}
          style={{ display:"none", background:"none", border:"none", cursor:"pointer",
            padding:6, color:P.textMed, alignItems:"center", justifyContent:"center" }}
          aria-label="Toggle menu">
          {menuOpen ? <FiX size={22}/> : <FiMenu size={22}/>}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={{ background:"#fff", borderTop:`1px solid ${P.border}`,
          padding:"14px 20px 18px", display:"flex", flexDirection:"column", gap:6 }}>
          {[["Features","features"],["How It Works","how-it-works"],["Pricing","pricing"],["Contact","contact"]].map(([lbl,id])=>(
            <button key={id} onClick={()=>nav(id)}
              style={{ ...linkStyle, textAlign:"left", padding:"11px 12px",
                borderRadius:8, fontSize:"0.95rem" }}
              onMouseEnter={e=>e.currentTarget.style.background="#f4f7fd"}
              onMouseLeave={e=>e.currentTarget.style.background="none"}>
              {lbl}
            </button>
          ))}
          <button onClick={()=>nav("contact")}
            style={{ marginTop:6, background:"linear-gradient(135deg,#054bb4,#2e5caf)", color:"#fff",
              padding:13, borderRadius:12, border:"none", cursor:"pointer",
              fontWeight:700, fontSize:"0.95rem", fontFamily:"Inter,sans-serif" }}>
            Book a Demo →
          </button>
        </div>
      )}
    </header>
  );
}
